// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tool-menu-dropdown-menu-g5wnxW{width:210px;max-height:590px}@media screen and (max-height:750px){.tool-menu-dropdown-menu-g5wnxW{max-height:400px}}.dropdown-item-xhf7Ug{display:block}.dropdown-item-container-RMjous{flex-direction:row;align-items:center;width:100%;font-weight:400;display:flex}.dropdown-item-text-_9tMKC{margin-left:8px;font-size:14px;font-weight:400;line-height:20px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tool-menu-dropdown-menu": `tool-menu-dropdown-menu-g5wnxW`,
	"toolMenuDropdownMenu": `tool-menu-dropdown-menu-g5wnxW`,
	"dropdown-item": `dropdown-item-xhf7Ug`,
	"dropdownItem": `dropdown-item-xhf7Ug`,
	"dropdown-item-container": `dropdown-item-container-RMjous`,
	"dropdownItemContainer": `dropdown-item-container-RMjous`,
	"dropdown-item-text": `dropdown-item-text-_9tMKC`,
	"dropdownItemText": `dropdown-item-text-_9tMKC`
};
export default ___CSS_LOADER_EXPORT___;
